import { gql } from '@apollo/client';

export const SHOP_STORE_CODE_QUERY = gql`
  query ShopStoreCodeQuery($country: String!, $language: String!) {
    magento2 {
      countryStoreCode(country_code: $country, language: $language) {
        allStores {
          storeId
          storeCode
        }
      }
    }
  }
`;
